import { LoadingOutlined } from '@ant-design/icons';
import { Form, notification, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import {
  formatarCnpjCpfIMask,
  removeCaracteresEspeciais,
} from '../../../../../helpers/formatador';
import apiNetCore from '../../../../../services/apiNetCore';

export default function SelectClienteEndereco({
  label,
  clienteOrigemDestino,
  setClienteOrigemDestino,
  disabled,
  setAlertMessageErrors,
  tipo,
}) {
  const [apiClientes, setApiClientes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);
  const { addContatoAction } = useContatosContext();

  const capitalize = text =>
    text.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());

  const handleSelectCliente = (_value, { idcliente, idendereco }) => {
    if (!idcliente) return;

    const {
      clienteEndereco,
      idCliente,
      nomeFantasia,
      razaoSocial,
      cnpj,
      clienteEmails,
    } = apiClientes.find(apiCliente => apiCliente.idCliente === idcliente);

    if (clienteEndereco.length === 0) {
      setAlertMessageErrors(state => [
        ...state,
        {
          key: 'cliente-enderaco-error',
          message:
            'Remetente e/ou Destinatário não possui endereços. Contate a nossa equipe comercial para mais informações',
          fixed: false,
        },
      ]);
      return;
    }

    const enderecoSelected =
      clienteEndereco.length > 0
        ? clienteEndereco.find(
            endereco => endereco.idClienteEndereco === idendereco
          )
        : '';

    const clientes = [...clienteOrigemDestino];

    if (
      clienteOrigemDestino.find(
        cli => cli.idClienteEndereco === enderecoSelected.idClienteEndereco
      )
    ) {
      return;
    }

    clientes.push({
      idCliente,
      idClienteEndereco: enderecoSelected.idClienteEndereco,
      idCidade: enderecoSelected.idCidade,
      ibgeCidade: enderecoSelected.ibgeCidade,
      idEstado: enderecoSelected.idEstado || undefined,
      nomeCliente: nomeFantasia || razaoSocial,
      cnpj: cnpj || undefined,
      cidade: enderecoSelected.cidade || undefined,
      estado: enderecoSelected.uf || undefined,
      cep: enderecoSelected.cep || undefined,
      bairro: enderecoSelected.bairro || undefined,
      endereco: enderecoSelected.endereco || undefined,
      clienteEmails: clienteEmails || undefined,
    });

    if (tipo === 'Remetente' || tipo === 'Expedidor') {
      if (clientes) {
        const emails = clientes.flatMap(cli => cli.clienteEmails);
        if (emails) {
          emails.forEach(email => {
            if (email) {
              addContatoAction(email);
            }
          });
        }
      }
    }

    setClienteOrigemDestino(clientes);
  };

  const handleSearchClientes = async value => {
    if (!value || value.length < 3) return;

    const valueFormated = removeCaracteresEspeciais(value);

    if (valueFormated.length < 3) return;

    setLoadingClientes(true);

    try {
      const { data } = await apiNetCore.get('/ClienteAts/GetClientes', {
        params: {
          clienteParametro: valueFormated,
        },
      });
      setApiClientes(data);
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os clientes',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
    setLoadingClientes(false);
  };

  const onSearchClientes = useDebouncedCallback(async value => {
    handleSearchClientes(value);
  }, 1000);

  const selectOptionCliente = (cliente, endereco = '') => (
    <Select.Option
      key={endereco.idClienteEndereco || cliente.idCliente}
      value={endereco.idClienteEndereco || cliente.idCliente}
      idcliente={cliente.idCliente}
      idendereco={endereco.idClienteEndereco}
    >
      {`${cliente.razaoSocial} - ${formatarCnpjCpfIMask(cliente.cnpj)}`}
      <br />
      {endereco &&
        `(${endereco.uf}) ${capitalize(endereco.cidade)} - ${
          endereco.endereco
        } - ${endereco.bairro}`}
    </Select.Option>
  );

  return (
    <>
      <Form.Item label={label} style={{ marginBottom: '6px' }}>
        <Select
          showSearch
          placeholder="Pesquisar por nome, razão social ou CNPJ"
          aria-label="selectClienteEndereco"
          disabled={disabled}
          showAction={['click']}
          filterOption={false}
          showArrow={false}
          loading={loadingClientes}
          value={null}
          onSelect={handleSelectCliente}
          onSearch={onSearchClientes}
          notFoundContent={loadingClientes ? <LoadingOutlined /> : null}
        >
          {apiClientes.map(dado => {
            if (dado.clienteEndereco.length > 0) {
              return dado.clienteEndereco.map(endereco =>
                selectOptionCliente(dado, endereco)
              );
            }
            return selectOptionCliente(dado);
          })}
        </Select>
      </Form.Item>
    </>
  );
}

SelectClienteEndereco.propTypes = {
  label: PropTypes.string,
  clienteOrigemDestino: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteOrigemDestino: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  setAlertMessageErrors: PropTypes.func.isRequired,
  tipo: PropTypes.string.isRequired,
};

SelectClienteEndereco.defaultProps = {
  label: '',
};
